import set from "lodash/set"
import { parseRes, parseErr } from "./api/_"

const plugin: NuxtPlugin = ({ $axios, app, store, $config, $sentry }) => {
  $axios.onRequest((req) => {
    if (!req.params) req.params = {}

    // Устанавливаем локаль
    req.params.lang = app.i18n.locale

    // Устанавливаем event
    if (typeof req.data?.query === "string" &&
      req.data.query.includes("listMyEventParticipation")) {
      delete req.params.event
    } else if (!req.params.event) {
      const event = store.state.app.customEvent || $config.event
      req.params.event = event
    }
  })

  // Парсим ответ
  $axios.onResponse((res) => { res.data = parseRes(res) })

  $axios.onResponseError((err) => {
    // Репортим в Sentry
    let [req, res]: Record<string, any>[] = [{}, {}]
    try {
      req = JSON.parse(err.config.data)
      res = JSON.parse(JSON.stringify(err.response?.data || {}))

      const message = res.errors?.[0]?.message
      if (message)
        console.error(message)
    } catch {}
    if (Object.keys(req).length || Object.keys(res).length) {
      $sentry.setContext("request", req)
      $sentry.setContext("response", res)
      $sentry.captureException(err)
    }

    // Унифицируем сообщение об ошибке
    set(err, "response.data", parseErr(app.i18n)(err))
  })
}
export default plugin

declare module "axios" { interface AxiosRequestConfig { cache?: boolean }}
